import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import userManager from './auth/userManagerInstance';
import router from './router';
import { store } from './store';
import i18n from './i18n';
import './plugins/vuetify-money.js';
import utils from './plugins/utils';

Vue.config.productionTip = false;

userManager
  .init()
  .then(() => {
    new Vue({
      vuetify,
      router,
      store,
      i18n,
      utils,
      render: h => h(App),
    }).$mount('#app');
  })
  .catch(err => {
    console.error(err);
    return false;
  });

export const eventBus = new Vue();
